/* eslint-disable */
// src/services/visitMachineCounterVerificationService.js

import axios from "services/axiosConfig";

const API_URL = "/api/visit-machine-counter-verification";

class VisitMachineCounterVerificationService {
  static async getLocalMachineCounterVerificationContext(
    localMachineId,
    { visitDateTime, beforeVisitId } = {}
  ) {
    try {
      const params = {};
      if (visitDateTime) params.visitDateTime = visitDateTime;
      if (beforeVisitId) params.beforeVisitId = beforeVisitId;

      const response = await axios.get(
        `${API_URL}/local-machine/${localMachineId}/context`,
        { params }
      );
      return response.data || null;
    } catch (error) {
      console.error("Error al obtener contexto de verificacion de contadores:", {
        localMachineId,
        visitDateTime,
        beforeVisitId,
        status: error?.response?.status,
        data: error?.response?.data,
        message: error?.message,
      });
      return null;
    }
  }
}

export default VisitMachineCounterVerificationService;
